import { render, staticRenderFns } from "./alopeci-peruk.vue?vue&type=template&id=00982f0e&scoped=true&"
import script from "./alopeci-peruk.vue?vue&type=script&lang=js&"
export * from "./alopeci-peruk.vue?vue&type=script&lang=js&"
import style0 from "./alopeci-peruk.vue?vue&type=style&index=0&id=00982f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00982f0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContent,VLayout})
